// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

import { Form } from "@/components/core";

export function NavbarSelect({
  value,
  placeholder,
  options,
  renderItem,
  onChange,
  hideBorder,
  color,
}: any) {
  const theme = useTheme();

  return (
    <Form.Select
      sx={{
        color: color ?? theme.palette.text.contrast,

        ".MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.text.contrast,
          borderWidth: hideBorder ? 0 : 2,
          padding: 0,
          margin: 0,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.text.contrast,
        },

        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.text.contrast,
        },
      }}
      value={value}
      placeholder={placeholder}
      options={options}
      renderItem={renderItem}
      onChange={onChange}
    />
  );
}

NavbarSelect.propTypes = {
  value: PropTypes.any,
  placeholder: PropTypes.any,
  options: PropTypes.array,
  renderItem: PropTypes.func,
  onChange: PropTypes.func,
  hideBorder: PropTypes.bool,
  color: PropTypes.string,
};
